module.exports = __webpack_public_path__ + "static/profile-0a34861f22e8487cceebeb8b07f5c76f.jpg";